import { GDPRConfig } from '@ecg-marktplaats/gdpr-consent-string';
import postUserConsent from '../api/postUserConsent';
import logGAEvent from '../helpers/logGAEvent';
import removeConsentBanner from '../helpers/removeConsentBanner';

/**
 * This function handles all the logic for when a user has
 * refused consent.
 *
 * @param gdprConsentString - this is the instantiated GdprConsentString class
 *  from `@ecg-marktplaats/gdpr-consent-string`
 * @param eventAction - this is the event action to log to Google Analytics.
 *  It's either `EVENT_ACTION.REFUSED_CONSENT`
 */
const refuseConsent = async (gdprConsentString, eventAction) => {
  /**
   * Saves the TCString to cookies (nothing has been accepted)
   * then returns the TCString
   */
  gdprConsentString.saveConsentString();

  if (GDPRConfig.userLoggedIn) {
    /**
     * Post the TCString to the back end for record keeping
     */
    await postUserConsent(gdprConsentString);
  }

  /**
   * Log refused consent to Google Analytics
   */
  logGAEvent(eventAction);

  /**
   * Remove the consent banner from the DOM
   */
  removeConsentBanner();
};

export default refuseConsent;
